"use strict";

(function ($, Drupal) {
  'use strict';

  //Footer tabs 
  var widthScreen = $(window).width();
  function togleTabs(target) {
    if (target.hasClass('active')) {
      target.removeClass('active');
      target.children('nav').slideUp();
      $('.footer .menus-section .col-xs.col-md-3 .row .col').children('nav').slideUp();
    } else {
      $('.footer .menus-section .col-xs nav').slideUp();
      $('.footer .menus-section .col-xs.col-md-4').removeClass('active');
      target.addClass('active');
      target.children('nav').slideDown();
    }
  }
  var footerAccordion = function footerAccordion(media) {
    var items = $('.footer .menus-section .row').children();
    if (media.matches) {
      items.each(function (i, e) {
        var linkTitle = e.firstElementChild;
        $(e.lastElementChild).slideUp();
        $(linkTitle).click(function (_ref) {
          var target = _ref.target;
          return togleTabs($(target.parentElement));
        });
      });
    } else {
      items.each(function (i, e) {
        return $(e.lastElementChild).slideDown();
      });
    }
  };

  //Footer resize
  var mqMax768 = window.matchMedia("(max-width: 768px)");
  footerAccordion(mqMax768);
  mqMax768.addListener(footerAccordion);
})(jQuery, Drupal);